import includes from 'lodash/includes';

export default result => {
  if (Array.isArray(result)) {
    return true;
  }
  return result && !includes(result.api_uri, 'error');
};
